import { Component, ViewChild } from "@angular/core";
import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { DxDataGridComponent, DxSelectBoxComponent } from "devextreme-angular";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from 'file-saver';
import { Observable, forkJoin, of } from 'rxjs';
import { NotificationService } from "src/app/common/component/notification/notification.service";
import { environment } from "src/environments/environment";
import { SmrAndAsuAwardsReportFilter } from "./smr-and-asu-awards-report-filters";
import { SmrAndAsuAwardsReportService } from "./smr-and-asu-awards-report.service";

@Component({
    selector: 'smr-and-asu-awards-report',
    templateUrl: 'smr-and-asu-awards-report.component.html',
    styleUrls: ['smr-and-asu-awards-report.component.scss']
})

export class SMRAndASUAwardsReportComponent {
    smrAndAsuAwardsReportFilterData: any[];
    countryDataSource: any[];
    selectedCountry: string;
    provinceDataSource: any;
    selectedProvinces: any;
    cityDataSource: any;
    selectedCities: any;
    reportDataSource: any[];
    asuAwardsReportDataSource: any[];
    mapMarkers: any = [];
    markers: any[] = [];
    asuAwardsReportMarkers: any[];
    colors: any[];
    asuAwardsReportcolors: any[];
    size: any[];
    asuAwardsReportSize: any[];
    map: google.maps.Map;
    infoWindow: google.maps.InfoWindow;
    asuAwardsData: Observable<any[]> = of([]);
    addASUAwards: boolean = false;

    @ViewChild("country", { static: false }) country: DxSelectBoxComponent;
    @ViewChild("H2AwardsSteamReformersGrid", { static: false }) steamReformerDataGrid: DxDataGridComponent;
    @ViewChild("ASUAwardsReportGrid", { static: false }) asuAwardsDataGrid: DxDataGridComponent;

    isLoadPanelVisible: boolean = false;

    constructor(private notificationService: NotificationService, private smrAndAsuAwardsReportService: SmrAndAsuAwardsReportService) {

        this.isLoadPanelVisible = true;
        smrAndAsuAwardsReportService.getSmrAndAsuAwardsReportFilter().subscribe({
            next: data => {
                this.smrAndAsuAwardsReportFilterData = data;
                this.countryDataSource = data.map((item) => item.countryName).filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a > b ? 1 : -1);
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching H2 Steam Reformer Awards Report", error);
            }
        });
    }

    onCountryChanged(e) {
        if (e.value && e.value.length > 0) {
            this.provinceDataSource = this.smrAndAsuAwardsReportFilterData.filter((item) => e.value.indexOf(item.countryName) >= 0).map((item) => item.province).filter((value, index, self) => self.indexOf(value) === index).sort();
            this.selectedProvinces = this.provinceDataSource;
        }
    }

    onProvinceChanged(e) {
        if (e.value && e.value.length > 0) {
            this.cityDataSource = this.smrAndAsuAwardsReportFilterData.filter((item) => e.value.indexOf(item.province) >= 0).map((item) => item.city).filter((value, index, self) => self.indexOf(value) === index).sort();
            this.selectedCities = this.cityDataSource;
        }
    }

    exportExcel(e) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: this.steamReformerDataGrid.instance,
            worksheet: worksheet
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer: BlobPart) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'H2SteamReformerAwardsReport.xlsx');
                });
        }).then(() => {
        });
        e.cancel = true;
    }

    exportASUAwardsExcel(e) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: this.asuAwardsDataGrid.instance,
            worksheet: worksheet
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer: BlobPart) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ASUAwardsReport.xlsx');
                });
        }).then(() => {
        });
        e.cancel = true;
    }

    getReports() {
        if (this.selectedCountry && this.selectedCountry.length > 0 && this.selectedProvinces && this.selectedProvinces.length > 0
            && this.selectedCities && this.selectedCities.length > 0) {

            this.isLoadPanelVisible = true;
            var smrData = this.smrAndAsuAwardsReportService.getH2SteamReformerAwardsReport(new SmrAndAsuAwardsReportFilter(this.selectedCountry, this.selectedProvinces, this.selectedCities));

            if (this.addASUAwards) {
                this.asuAwardsData = this.smrAndAsuAwardsReportService.getASUAwardsReport(new SmrAndAsuAwardsReportFilter(this.selectedCountry, this.selectedProvinces, this.selectedCities));
            } else {
                this.asuAwardsData = of([]);
                this.asuAwardsReportDataSource = [];
                this.asuAwardsReportMarkers = [];
                this.asuAwardsReportSize = [];
                this.asuAwardsReportcolors = [];
            }

            forkJoin([smrData, this.asuAwardsData]).subscribe(([smrArray, asuAwardsArray]) => {

                const mapContgrol = document.getElementById("map") as HTMLElement;
                const colorLegendContgrol = document.getElementById("techProviderLegend") as HTMLElement;
                const sizeLegendContgrol = document.getElementById("sizeLegend") as HTMLElement;

                if ((smrArray && smrArray.length > 0) || (asuAwardsArray && asuAwardsArray.length > 0)) {
                    mapContgrol.hidden = false;
                    colorLegendContgrol.hidden = false;
                    sizeLegendContgrol.hidden = false;

                } else {
                    mapContgrol.hidden = true;
                    colorLegendContgrol.hidden = true;
                    sizeLegendContgrol.hidden = true;
                    this.isLoadPanelVisible = false;
                    return;
                }

                this.reportDataSource = smrArray;
                this.reportDataSource = this.reportDataSource;
                this.asuAwardsReportcolors = [];
                this.size = [];
                this.markers = [];

                this.markers = [...this.reportDataSource].map(item => item).sort((a, b) => b.hydrogen - a.hydrogen);
                this.colors = this.reportDataSource.map(item => <any>{ technologyProviderColor: item.technologyProviderColor, technologyProvider: item.technologyProvider })
                    .filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => (a.technologyProvider > b.technologyProvider ? 1 : -1));
                this.size = this.reportDataSource.filter(x => x.hydrogen).map(item => <any>{ h2Size: item.ranges.split(',')[1], h2SizeRange: item.ranges.split(',')[0] }).sort((a, b) => a.h2Size - b.h2Size);

                if (asuAwardsArray) {
                    this.asuAwardsReportDataSource = asuAwardsArray;
                    this.asuAwardsReportcolors = [];
                    this.asuAwardsReportSize = [];
                    this.asuAwardsReportMarkers = [];

                    this.asuAwardsReportMarkers = [...this.asuAwardsReportDataSource].map(item => item).sort((a, b) => b.totalOxygen - a.totalOxygen);
                    this.asuAwardsReportcolors = this.asuAwardsReportDataSource.map(item => <any>{ color: item.color, manufacturer: item.manufacturer })
                        .filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => (a.manufacturer > b.manufacturer ? 1 : -1));
                    this.asuAwardsReportSize = this.asuAwardsReportDataSource.filter(x => x.totalOxygen).map(item => <any>{ h2Size: item.ranges.split(',')[1], h2SizeRange: item.ranges.split(',')[0] }).sort((a, b) => a.h2Size - b.h2Size);
                }
                this.initMap();
                this.isLoadPanelVisible = false;
            });


        } else if (!(this.selectedCountry)) {
            this.country.validationStatus = "invalid"
        }
    }

    initMap(): void {

        const loader = new Loader({
            apiKey: environment.gmaps,
            version: 'weekly'
        });

        loader.load().then((google) => {
            this.mapMarkers = [];
            this.map = new google.maps.Map(document.getElementById("map") as HTMLElement, {
                center: {
                    lat: this.markers && this.markers.length > 0 ? this.markers[0].latitude : this.asuAwardsReportMarkers[0].latitude,
                    lng: this.markers && this.markers.length > 0 ? this.markers[0].longitude : this.asuAwardsReportMarkers[0].longitude
                },
                zoom: 4,
                mapTypeId: 'roadmap'
            });

            this.infoWindow = new google.maps.InfoWindow();
            const techProviderLegend = document.getElementById("techProviderLegend") as HTMLElement;

            if (this.colors.length > 0) {
                techProviderLegend.hidden = false;
                techProviderLegend.innerHTML = "";
                techProviderLegend.innerHTML = '<b>Color = Tech Provider</b><hr/>'
            } else {
                techProviderLegend.hidden = true;
            }


            const sizeLegend = document.getElementById("sizeLegend") as HTMLElement;
            if (this.size.length > 0) {
                sizeLegend.hidden = false;
                sizeLegend.innerHTML = "";
                sizeLegend.innerHTML = '<b>Size = H2 Qty (kNm3/h)</b><hr/>';
            } else {
                sizeLegend.hidden = true;
            }
            let colorcodes = [];

            this.colors.forEach((item, index) => {
                if (colorcodes.indexOf(item.technologyProvider) < 0) {
                    const div = document.createElement("div");
                    div.innerHTML = '<svg height="20" width="40">  <circle cx="15" cy="12" r="' + 8 + '" stroke-width="3" fill="' + item.technologyProviderColor + '" /> </svg>' + item.technologyProvider.replace("<", "&lt;");
                    techProviderLegend.appendChild(div);
                    colorcodes.push(item.technologyProvider);
                }
            });

            colorcodes = [];

            if (this.asuAwardsReportcolors.length > 0) {
                const manufacturerLegend = document.getElementById("manufacturerLegend") as HTMLElement;
                manufacturerLegend.innerHTML = "";
                manufacturerLegend.innerHTML = '<b>Color = ASU Manufacturer</b><hr/>'
                this.asuAwardsReportcolors.forEach((item, index) => {
                    if (colorcodes.indexOf(item.manufacturer) < 0) {
                        const newdiv = document.createElement("div");
                        newdiv.innerHTML = '<svg height="20" width="70">  <path d="M 20,5 40,57.5 1,57.5 z" fill="' + item.color + '" /> </svg>' + item.manufacturer.replace("<", "&lt;");
                        manufacturerLegend.appendChild(newdiv);
                        colorcodes.push(item.manufacturer);
                    }
                });
            }

            let uniqueZize = [];

            this.size.forEach((item, index) => {
                if (item.h2Size && uniqueZize.indexOf(item.h2Size) < 0) {
                    const div = document.createElement("div");
                    div.innerHTML = '<svg height="40" width="40">  <circle cx="20" cy="20" r="' + item.h2Size + '" stroke-width="3" class="blue-circle" /> </svg>' + item.h2SizeRange;
                    sizeLegend.appendChild(div);
                    uniqueZize.push(item.h2Size)
                }
            })



            if (this.asuAwardsReportSize && this.asuAwardsReportSize.length > 0) {
                uniqueZize = [];
                const asuSizeLegend = document.getElementById("asuSizeLegend") as HTMLElement;
                asuSizeLegend.innerHTML = "";
                asuSizeLegend.innerHTML = '<b>Size = ASU O2 Qty (tonne/d)</b><hr/>';
                this.asuAwardsReportSize.forEach((item, index) => {
                    if (item.h2Size && uniqueZize.indexOf(item.h2Size) < 0) {
                        const div = document.createElement("div");
                        //height="' +  + '
                        div.innerHTML = '<svg width="80" height="70" style="scale: '+Number.parseFloat(item.h2Size) *1.9* 100+'%;">  <path class="blue-circle" d="M 20,5 40,57.5 1,57.5 z"/> </svg>' + item.h2SizeRange;
                        asuSizeLegend.appendChild(div);
                        uniqueZize.push(item.h2Size)
                    }
                })
            }

            for (let i of this.markers) {


                const tempMarker = new google.maps.Marker({
                    position: { lat: i.latitude, lng: i.longitude }, icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: i.ranges && i.ranges.length > 0 ? i.ranges.split(',')[1] - 3 : 7,
                        fillOpacity: 1,
                        strokeColor: i.technologyProviderColor,
                        fillColor: i.technologyProviderColor
                    }, map: this.map
                });
                tempMarker.addListener('mouseover', ((tempMarker, map, infoWindow) => {
                    return () => {
                        infoWindow.setContent('<p>' + i.technologyProvider.replace("<", "&lt;") + ', ' + i.city + ', ' + i.province + '</p>');
                        infoWindow.open(map, tempMarker);
                    }
                })(tempMarker, this.map, this.infoWindow));

                tempMarker.addListener('mouseout', ((tempMarker, map, infoWindow) => {
                    return () => {

                        infoWindow.close();
                    }
                })(tempMarker, this.map, this.infoWindow));

                this.mapMarkers.push(tempMarker);
            }

            if (this.asuAwardsReportMarkers && this.asuAwardsReportMarkers.length > 0) {
                for (let i of this.asuAwardsReportMarkers) {


                    const tempMarker = new google.maps.Marker({
                        position: { lat: i.latitude, lng: i.longitude }, icon: {
                            path: "M 20,5 40,57.5 1,57.5 z",
                            scale: i.ranges && i.ranges.length > 0 ? Number.parseFloat(i.ranges.split(',')[1])* 1.8 : 0.2,
                            fillOpacity: 1,
                            strokeColor: i.color,
                            fillColor: i.color
                        }, map: this.map
                    });
                    tempMarker.addListener('mouseover', ((tempMarker, map, infoWindow) => {
                        return () => {
                            infoWindow.setContent('<p>' + i.manufacturer.replace("<", "&lt;") + ', ' + i.city + ', ' + i.province + '</p>');
                            infoWindow.open(map, tempMarker);
                        }
                    })(tempMarker, this.map, this.infoWindow));

                    tempMarker.addListener('mouseout', ((tempMarker, map, infoWindow) => {
                        return () => {

                            infoWindow.close();
                        }
                    })(tempMarker, this.map, this.infoWindow));

                    this.mapMarkers.push(tempMarker);
                }
            }

            new MarkerClusterer({ map: this.map, markers: this.mapMarkers });
        });
    }

}